export let ACTIONS = /*#__PURE__*/function (ACTIONS) {
  ACTIONS["ADMIN_LOGIN_AS_USER"] = "ADMIN_LOGIN_AS_USER";
  ACTIONS["CANCEL_ITEMS"] = "CANCEL_ITEMS";
  ACTIONS["TRANSFER_ITEMS"] = "TRANSFER_ITEMS";
  ACTIONS["IN_STOCK_ADJUSTMENT"] = "IN_STOCK_ADJUSTMENT";
  ACTIONS["SET_FLAT_RATES"] = "SET_FLAT_RATES";
  ACTIONS["CHANGE_ORDER_SHIPPING_INFORMATION"] = "CHANGE_ORDER_SHIPPING_INFORMATION";
  ACTIONS["CANCEL_DISTRIBUTION_RECEIVER"] = "CANCEL_DISTRIBUTION_RECEIVER";
  ACTIONS["UPDATE_DISTRIBUTION_RECEIVER_TRACKING"] = "UPDATE_DISTRIBUTION_RECEIVER_TRACKING";
  ACTIONS["UPDATE_DISTRIBUTION_RECEIVER_ADDRESS"] = "UPDATE_DISTRIBUTION_RECEIVER_ADDRESS";
  ACTIONS["UPDATE_DISTRIBUTION_RECEIVER_WAREHOUSE_SHIPMENT_NUMBER"] = "UPDATE_DISTRIBUTION_RECEIVER_WAREHOUSE_SHIPMENT_NUMBER";
  ACTIONS["UPDATE_ITEM_EMBELLISHMENT_METHOD"] = "UPDATE_ITEM_EMBELLISHMENT_METHOD";
  ACTIONS["ADJUST_STORAGE_FEE"] = "ADJUST_STORAGE_FEE";
  ACTIONS["UPDATE_INVENTORY"] = "UPDATE_INVENTORY";
  ACTIONS["UPDATE_CUSTOM_BOX_COLOR"] = "UPDATE_CUSTOM_BOX_COLOR";
  ACTIONS["RECREATE_VERTEX_TRANSACTION"] = "RECREATE_VERTEX_TRANSACTION";
  ACTIONS["UPDATE_ITEM_SIZE_BREAKDOWN"] = "UPDATE_ITEM_SIZE_BREAKDOWN";
  ACTIONS["UPDATE_EXPECTED_BY_CUSTOMER_DATES"] = "UPDATE_EXPECTED_BY_CUSTOMER_DATES";
  ACTIONS["UPDATE_CONFIRMED_BY_VENDOR_DATES"] = "UPDATE_CONFIRMED_BY_VENDOR_DATES";
  ACTIONS["CHANGE_DEFAULT_WAREHOUSE"] = "CHANGE_DEFAULT_WAREHOUSE";
  ACTIONS["UPDATE_SHIPPING_MARGIN"] = "UPDATE_SHIPPING_MARGIN";
  ACTIONS["UPDATE_SPACE_SHIPPING_MARGIN"] = "UPDATE_SPACE_SHIPPING_MARGIN";
  ACTIONS["CHANGE_USER_EMAIL"] = "CHANGE_USER_EMAIL";
  ACTIONS["TRIGGER_ADVANCE_DISTRIBUTION"] = "TRIGGER_ADVANCE_DISTRIBUTION";
  ACTIONS["SET_REPLACEMENT_PAYMENT_COMPLETED"] = "SET_REPLACEMENT_PAYMENT_COMPLETED";
  ACTIONS["UPDATE_PRODUCT_STATUS"] = "UPDATE_PRODUCT_STATUS";
  ACTIONS["PRODUCT_NOTE"] = "PRODUCT_NOTE";
  ACTIONS["CUSTOM_INK_PRO_IMPERSONATE_EXTERNAL"] = "CUSTOM_INK_PRO_IMPERSONATE_EXTERNAL";
  ACTIONS["LOGIN_SWAG_ADMIN_AS_RESELLER"] = "LOGIN_SWAG_ADMIN_AS_RESELLER";
  return ACTIONS;
}({});
export const EditHistoryActionsTitles = {
  [ACTIONS.CANCEL_DISTRIBUTION_RECEIVER]: 'Cancel recipient',
  [ACTIONS.UPDATE_DISTRIBUTION_RECEIVER_TRACKING]: 'Edit tracking',
  [ACTIONS.UPDATE_DISTRIBUTION_RECEIVER_ADDRESS]: 'Edit recipient',
  [ACTIONS.UPDATE_DISTRIBUTION_RECEIVER_WAREHOUSE_SHIPMENT_NUMBER]: 'Edit order number',
  [ACTIONS.TRIGGER_ADVANCE_DISTRIBUTION]: 'Trigger fulfillment'
};
export const shippingFieldsMap = {
  domesticShippingMargin: 'domestic shipping margin',
  internationalShippingMargin: 'international shipping margin',
  taxesAndDutiesMargin: 'taxes and duties margin'
};
export let FieldsEnum = /*#__PURE__*/function (FieldsEnum) {
  FieldsEnum["WAREHOUSE_LOCATION"] = "warehouse location";
  FieldsEnum["COMPANY"] = "company";
  FieldsEnum["EMAIL"] = "email";
  FieldsEnum["ADDRESS"] = "address";
  FieldsEnum["CITY"] = "city";
  FieldsEnum["STATE"] = "state";
  FieldsEnum["UNIT"] = "unit";
  FieldsEnum["COUNTRY"] = "country";
  FieldsEnum["ZIP"] = "zip";
  FieldsEnum["DELIVERY_NOTE"] = "order note";
  return FieldsEnum;
}({});